import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

import { computed } from "vue";
import { quillDeltaToHtml } from "@/common/utils/quill";
import { styleZoom } from "@/common/utils/style";


export default /*@__PURE__*/_defineComponent({
  __name: 'front-cover',
  props: {
    company: {},
    data: {},
    print: { type: Boolean },
    style: {},
    zoom: {}
  },
  setup(__props: any) {

const props = __props;

const text = computed(() => {
  if (props.data.text) {
    return quillDeltaToHtml(props.data.text);
  }
  return "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", {
      print: props.print,
    }]),
    style: _normalizeStyle(_unref(styleZoom)(__props.style, __props.zoom))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.company?.avatar)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: __props.company.avatar.base64,
                alt: "avatar",
                style: _normalizeStyle(
              _unref(styleZoom)(
                {
                  'max-width': '150px',
                },
                __props.zoom,
              )
            )
              }, null, 12, _hoisted_3)
            ]),
            _createElementVNode("div", {
              class: "text",
              innerHTML: text.value,
              style: _normalizeStyle(
            _unref(styleZoom)(
              {
                'text-align': __props.data.align,
                'font-size': __props.data.size,
                'font-family': __props.data.font_family,
              },
              __props.zoom,
            )
          )
            }, null, 12, _hoisted_4)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 6))
}
}

})